import { _Set } from '../../utils/lang/sets';
export function whitelistMatcherContext(ruleAttr) {
    var whitelistSet = new _Set(ruleAttr);
    return function whitelistMatcher(runtimeAttr) {
        var isInWhitelist = whitelistSet.has(runtimeAttr);
        return isInWhitelist;
    };
}
